import PayPalDonate from './PayPalDonate';

export default PayPalDonate;
